import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import WhatsappService from 'services/WhatsappService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
	pagination: {
		content: [],
		totalElements: 0,
		totalPages: 0,
		currentPage: 0,
		pageSize: 10,
	},
}

export const getAllPaginated = createAsyncThunk('whatsapp/allPaginated', async (params, { rejectWithValue }) => {
	try {
		const response = await WhatsappService.paginated(params)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar mensagens WhatsApp')
	}
})

export const all = createAsyncThunk('whatsapp/all',async () => {
    const response = await WhatsappService.all()
    return response;
})

export const whatsappService = createSlice({
	name: 'whatsapp',
	initialState,
	reducers: {
		
	},
    extraReducers: (builder) => {
		builder
			.addCase(getAllPaginated.pending, (state) => {
				state.loading = true
			})
			.addCase(getAllPaginated.fulfilled, (state, action) => {
				state.loading = false
				state.pagination = {
					content: action.payload.content,
					totalElements: action.payload.totalElements,
					totalPages: action.payload.totalPages,
					currentPage: action.payload.number,
					pageSize: action.payload.size,
				}
			})
			.addCase(getAllPaginated.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(all.pending, (state) => {
				state.all = null
				state.loading = true
			})
			.addCase(all.fulfilled, (state, action) => {
				state.loading = false
				state.all = action.payload
			})
			.addCase(all.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
	},
})

export const {
	showLoading,
} = whatsappService.actions

export default whatsappService.reducer